const html = document.querySelector("html");
const body = document.querySelector(".body");

//====== Registerd ScrollTrigger Plugin ==========
gsap.registerPlugin(ScrollTrigger);

function hideLoader(){
  tl.to(".loader-upper",{
    y:"-100%",
    duration:0.8,
    ease: "sine.inOut",
  })
}

//========= LENIS START =========
const lenis = new Lenis({
  duration: 1,
  smooth:true,
  infinite: false,
  syncTouch:false, // mimic touch device scroll while allowing scroll sync (can be unstable on iOS<16)
  smoothTouch: false,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  prevent: (node) => !!node.closest(".lenis-prevent")
});
//========= LENIS END =========

//======= LENIS SCROLL CONTROL =========
let isOpened = false;
function stopLenisScroll(){
  lenis.stop();
  isOpened = true;
}

function startLenisScroll(){
  lenis.start();
  isOpened = false;
}

//========= SCROLL & NAVBAR TOGGLE START =========
// const headerBottom = document.querySelector(".header");

let prevScrollPos = 0;
const scrollThreshold = 10;  // Prevents accidental small scroll triggers
const mobileMenu = document.querySelector(".aside-mobile");
const mobileMenuBody = mobileMenu.querySelector(".mobile-menu__body")
const overlay = document.querySelector(".overlay");

let lastScroll = 0;
function checkScroll(){
  let scroll = lenis.scroll || document.documentElement.scrollTop;
  scroll > lastScroll ? header.classList.add("hidden") : header.classList.remove("hidden");
  lastScroll = scroll;
  scroll > 100 ? header.classList.add("sticky") : header.classList.remove("sticky");
}
//========= SCROLL & NAVBAR TOGGLE END =========

//======= ACTIVE NAVIGATION LINK START =========
const windowPathname = window.location.pathname;
const navLinks = document.querySelectorAll(".navbar__link");

navLinks.forEach(link =>{
  const navLinkPathname = new URL(link.href, window.location.origin).pathname;
  const isValidLink = navLinkPathname === "/" || navLinkPathname.endsWith(".html");
  if(!isValidLink){
    link.classList.remove("active");
    return;
  }
  const isActiveLink = windowPathname === navLinkPathname || (windowPathname === "/index.html" && navLinkPathname === "/")
  link.classList.toggle("active", isActiveLink);
});
//======= ACTIVE NAVIGATION LINK END =========

//======= BANNER CONTENT ANIMATION START =========
function bannerContentsAnimation(){
  const tl = gsap.timeline();
  // Header Animation Start
  tl.from([".header-top__list li",".header__logo", ".header-btn"], {
    opacity: 0,
    y: 50,
    delay: 0.2,
    duration: 1,
    stagger:0.1,
    ease: Expo.easeInOut,
  });
  tl.from([".navbar__link", "#hamburger-btn"], {
      opacity:0,
      y:40,
      duration:0.8,
      stagger:0.1,
      delay:-1,
      ease:"power4.out",
    }
  );
  // Header Animation End

  tl.from(".hero-title", {
    opacity: 0,
    duration: 1,
    // y: 50,
    delay: -1.15,
    stagger:0.1,
    // ease: "power4.in",
  });
  const heroSubTitles = document.querySelectorAll(".hero-subTitle");
  heroSubTitles && tl.from(heroSubTitles, {
    opacity: 0,
    duration: 1,
    y: 50,
    delay: -1.25,
    stagger:0.1,
    ease: "power4.out",
  });
  
  const heroBtns = document.querySelectorAll(".hero-btn");
  heroBtns && heroBtns.forEach((heroBtn)=>{
    tl.from(heroBtn, {
      opacity: 0,
      duration: 1,
      y: 50,
      delay: -1,
      stagger:0.1,
      ease: "power4.out",
    });
  })

  tl.fromTo(".banner-counter-wrapper",
    {
      opacity:0,
      scale:0,
      transformOrigin:"left",
    },{
      opacity:1,
      scale:1,
      duration:1,
      delay:-1.65,
      stagger:0.15,
      ease:"power4.inOut",
    }
  )

  const bannerImage = document.querySelectorAll(".bannerImg");
  bannerImage && tl.from(bannerImage, {
    opacity: 0,
    scale:1.15,
    // y: 30,
    duration: 1.2,
    delay: -2.10,
    stagger:0.1,
    ease:"power2.out",
  });
  

  tl.from(".form__group",{
    opacity:0,
    y:30,
    duration:0.8,
    delay:-2,
    stagger:0.1,
    ease:"power4.in"
  })

  tl.from(".team-img", {
    opacity:0,
    y:50,
    duration:1,
    stagger:0.1,
    delay:-2,
    ease:"power4.in"
  })

  tl.from(".socials__list li",{
    opacity:0,
    y:30,
    delay:-1.65,
    duration:1,
    stagger:0.2,
    ease:"power4.inOut"
  });
}
//======= BANNER CONTENT ANIMATION END =========

//====== TOGGLE MOBILE SUBMENU START ==========
const mobileMenuLinks = document.querySelectorAll(".mobile-menu__item");
const mobileMenuLinksArr = Array.from(mobileMenuLinks);
const hamburgerBtn = document.getElementById("menuToggle");

const tl = gsap.timeline();
hamburgerBtn.addEventListener('click', function(){
  this.classList.toggle("active");
  mobileMenu.classList.toggle("show");
  overlay.classList.toggle("show");
  mobileMenuLinksArr.forEach((mobileLink)=>{
    gsap.fromTo(mobileLink,
      {
        opacity:0,
        y:50,
      },{
        opacity:1,
        y:0,
        duration:1,
        stagger:1,
        ease:"power4.inOut"
      }
    );
  });

  tl.fromTo(".socials__item", 
    {
      opacity:0,
      y:40,
    },{
      opacity:1,
      y:0,
      stagger:0.2,
      delay:-0.1,
      duration:1,
      ease:"power4.inOut",
    }
  )
  !isOpened ? stopLenisScroll() : startLenisScroll();
});

window.addEventListener("resize", function(){
  const viewportWidth = this.screen.availWidth;
  const constentWidth = 1200;

  if(viewportWidth && viewportWidth >= constentWidth){
    mobileMenu.classList.remove("show");
    overlay.classList.remove("show");
    hamburgerBtn.classList.remove("active")
    startLenisScroll();
  }
})
//====== TOGGLE MOBILE SUBMENU END ==========

const submenuParents = document.querySelectorAll(".submenu-parent");
submenuParents.forEach((submenuParent)=>{
  const megamenuCols  = submenuParent.querySelectorAll(".mega-menu__column");

  submenuParent.addEventListener('mouseenter', () => {
    gsap.fromTo(megamenuCols, 
      {
        opacity:0,
        y:-12,
      },{
        opacity:1,
        y:0,
        stagger:0.15,
        ease:"power3.out"
      }
    )
  })
  
  submenuParent.addEventListener('mouseleave', () => {
    gsap.fromTo(megamenuCols, 
      {
        opacity:1,
        y:0,
        stagger:0.15,
        ease:"power3.out"
      },{
        opacity:0,
        y:-12,
      }
    )
  })
})

// ===== Lazy loading background images start =====
let lazyBackgrounds = [].slice.call(document.querySelectorAll("[data-bg]"));

if("IntersectionObserver" in window){
  const lazyBackgroundObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if(entry.isIntersecting){
        let lazyBackground = entry.target;
        let imgUrl = lazyBackground.getAttribute("data-bg");
        if(entry.target.classList.contains("overlay-gradient")){
            let linearGredient = "linear-gradient(to bottom, rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45))";
            lazyBackground.style.backgroundImage = `${linearGredient}, url("${imgUrl}")`;
        }else{
            lazyBackground.style.backgroundImage = `url("${imgUrl}")`;
        }
        lazyBackground.classList.remove("lazy");
        lazyBackgroundObserver.unobserve(lazyBackground);
      }
    });
  });

  lazyBackgrounds.forEach((lazyBackground) =>{
    lazyBackgroundObserver.observe(lazyBackground);
  });
}
// ===== Lazy loading background images End =====

//======== ACCORDION TOGGLE START ========
function toggleAccordion(element){ 
  const content = element.nextElementSibling;
  if(!content) return;
  const isOpen = element.classList.toggle("is-open");

  content.style.maxHeight = isOpen ? `${content.scrollHeight}px` : null ;

  if(isOpen){
    gsap.fromTo(content.children, 
      { opacity: 0, y:50 },
      { opacity: 1, y:0, duration:0.75, stagger:0.2, ease:"power4.out"}
    );
  }
}

function setupAccordion(selector){
  const items = document.querySelectorAll(selector);

  items.forEach(item=>{
    item.addEventListener("click", (e)=>{
      e.stopPropagation();
      toggleAccordion(item);
      
      items.forEach(other=>{
        if(other === item) return;
        other.classList.remove("is-open");
        const content = other.nextElementSibling;
        if(content){
          content.style.maxHeight = null;
        }
      });

    })
  })
}

setupAccordion(".accordion-title");
setupAccordion(".mobileSubmenu");
//======== ACCORDION TOGGLE END ========

//======= COUNTER START  ===========
function visible($el) {
  let $w = jQuery(window),
    viewTop = $w.scrollTop(),
    viewBottom = viewTop + $w.height(),
    elTop = $el.offset().top,
    elBottom = elTop + $el.height();
    compareTop = $el === true ? elBottom : elTop,
    compareBottom = $el === true ? elTop : elBottom;

  return (
    compareBottom <= viewBottom && compareTop >= viewTop && $el.is(":visible")
  );
}

function updateCounter(){
  ScrollTrigger.create({
    trigger: "#stats-section",
    start: "top 80%",
    once: true,
    onEnter: () => {
      if ($("#stats-section").hasClass("animated")) return; // already run
    
      $("#stats-section").addClass("animated"); // mark it as run
    
      document.querySelectorAll(".stats-number").forEach((el) => {
        const target = parseFloat(el.dataset.target);
        const formatType = el.dataset.format;
    
        gsap.fromTo(el,
          { innerText: 0 },
          {
            innerText: target,
            duration: 2,
            ease: "power1.out",
            snap: { innerText: 1 },
            onUpdate: function () {
              const value = Math.trunc(el.innerText);
              if (formatType === "abbreviated") {
                el.innerText = value;
              } else {
                el.innerText = value.toLocaleString("en-US");
              }
            }
          }
        );
      });
    }
    
  });
}
//======= COUNTER END ==========


//======= FLOATING INPUT LABLE START ======
document.querySelectorAll(".form__control").forEach((input) => {
  input.addEventListener("focus", ()=> input.nextElementSibling.classList.add("focused"));
  input.addEventListener("blur", ()=> input.nextElementSibling.classList.toggle("focused", input.value !== ""));
}); 
//======= FLOATING INPUT LABLE END ======

const swiperServices = new Swiper(".swiper-1",{
  spaceBetween: 10,
  slidesPerView: 1,
  grabCursor: true,
  effect: 'fade',
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },
  navigation:{
    nextEl:"#next-service",
    prevEl:"#prev-service",
  },
  // breakpoints:{
  //   576:{
  //     slidesPerView: 1.5,
  //     spaceBetween: 16,
  //   },
  //   768:{
  //     slidesPerView:1.75,
  //     spaceBetween: 20,         
  //   },
  //   992:{
  //     slidesPerView:1.75,
  //     spaceBetween: 20,         
  //   },
  // }
});

// Zoom In
gsap.utils.toArray(".zoom-in").forEach(box => {
  const image = box.querySelector("img");
  gsap.fromTo(image,
    {
      scale:1
    },
    {
      scale:1.15,
      ease:"none",
      scrollTrigger:{
        trigger:box,
        start:"top bottom",
        end:"bottom top",
        scrub:2
      }
    }
  );
});

// Zoom Out
gsap.utils.toArray(".zoom-out").forEach(box => {
  const image = box.querySelector("img");
  gsap.fromTo(image,
    {
      scale:1.15
    },
    {
      scale:1,
      ease:"none",
      scrollTrigger:{
        trigger:box,
        start:"top bottom",
        end:"bottom top",
        scrub:2
      }
    }
  );
});


// These are te default settings.
$('#slides').slideshow({
  randomize: true,      // Randomize the play order of the slides.
  slideDuration: 6000,  // Duration of each induvidual slide.
  fadeDuration: 1000,    // Duration of the fading transition. Should be shorter than slideDuration.
  animate: true,        // Turn css animations on or off.
  pauseOnTabBlur: false, // Pause the slideshow when the tab is out of focus. This prevents glitches with setTimeout().
  enableLog: false      // Enable log messages to the console. Useful for debugging.
});

// ======= Modal Script Start =======
const modal = document.getElementById("memberModal");
const closeModalBtn = document.getElementById("closeModalBtn");
const teamMembers = document.querySelectorAll(".readBioBtn");

teamMembers.forEach(member =>{
  member.addEventListener("click", (e)=>{
    // const modalImage = modal.querySelector(".modal-img");
    const modalName = modal.querySelector("#modalName");
    const modalTitle = modal.querySelector("#modalTitle");
    const modalDesc = modal.querySelector("#modalDescription");

    const thumbImageUrl = member.dataset.image;
    const name = member.dataset.name;
    const title = member.dataset.title;
    const desc = member.dataset.description;

    // modalImage.src = thumbImageUrl;
    // modalImage.alt = name;
    modalName.textContent = name;
    modalTitle.textContent = title;

    modalDesc.innerHTML = "";
    desc.split("\n").forEach((paragraph) =>{
      const trimmed = paragraph.trim();
      if(trimmed){
        const p = document.createElement("p");
        p.textContent = trimmed;
        modalDesc.appendChild(p);
      }
    });

    modal.classList.add("show");

    gsap.fromTo(".modal-content", 
      { y:50, opacity:0},
      { y:0, opacity:1, duration:0.5, ease:"power3.out"},
    );
    stopLenisScroll();
  });
});

// Close The Modal
const closeModal =()=>{
  gsap.to(".modal-content", {
    y:50, opacity:0, duration:0.5, ease:"power3.in",
    onComplete:()=>{
      modal.classList.remove("show");
      startLenisScroll();
    }
  });
}

closeModalBtn?.addEventListener("click", closeModal);

// Close Modal on background click
modal?.addEventListener("click", (e)=>{
  if(e.target === modal) closeModal();
});
// ======= Modal Script End =======


//========== Video Play /Pause Button Start ============
const playBtns = document.querySelectorAll(".play-btn");
if(playBtns){
  const videoContainer = document.querySelector(".video__popup-container");
  const closeBtn = document.querySelector(".video__popup-close");
  let iframe = document.querySelector(".video__popup-iframe-container > iframe");

  function togglePopup() {
    videoContainer.classList.toggle("show");
    gsap.fromTo(".video__popup-wrapper", 0.5,
      { opacity:0, y:50},
      { opacity:1, y:0, ease:Power4.easeOut }
    );
   stopLenisScroll();
  }

  playBtns.forEach((playBtn, index) => {
    playBtn.addEventListener("click",() => {
      const videoId = playBtn.dataset.id;
      iframe.src = `https://www.youtube.com/embed/${videoId}`;
      togglePopup();
    })
  });

  closeBtn && closeBtn.addEventListener("click", ()=>{
    iframe.src = "";
    togglePopup();
    startLenisScroll();
  });
}
//========== Video Play /Pause Button End ============

// ====== Scroll Back To Top Start ======
const backToTopBtn = document.getElementById("backToTop");
function toggleBackToTop(){
  if (window.scrollY > 1600) {
    backToTopBtn.classList.add("show");
    gsap.to(backToTopBtn, { autoAlpha: 1, duration: 0.5 });
  } else {
    backToTopBtn.classList.remove("show");
    gsap.to(backToTopBtn, { autoAlpha: 0, duration: 0.5 });
  }
}

backToTopBtn && backToTopBtn.addEventListener("click", () => {
  lenis.scrollTo(0); // This is the key part: Lenis handles smooth scroll
});
// ==== Scroll back To Top End ====

//====== SET SECTION WIDTH START =====
const elements = document.querySelectorAll("[data-maxWidth], [data-align]");
elements.forEach((el)=>{
  const {maxwidth, align} = el.dataset;
  const alignValue = align?.trim().toLowerCase();
  if(alignValue === "center"){
    el.style.marginInline = "auto";
    el.style.textAlign = alignValue;
  }
  if(alignValue === "right") el.style.textAlign = alignValue;
  if(maxwidth) el.style.maxWidth = maxwidth;
});
//====== SET SECTION WIDTH END =====

//====== ANIMATION SCRIPT START =========
const textContainers = gsap.utils.toArray(".fade-up");
textContainers.forEach((textContainer, i) => {
  gsap.fromTo(textContainer,
    { opacity: 0, y: 50 },
    { opacity: 1, y: 0, duration: 1, stagger:0.2, ease:"power2.out",
      scrollTrigger:{
        trigger: textContainer,
        toggleActions: "play none none none",
        once: true
      },
    }
  );
});

const fadeIn = gsap.utils.toArray(".fade-in");
fadeIn.forEach((mainContent, i) => {
  const anim = gsap.fromTo(mainContent,
    { opacity: 0 },
    { opacity: 1, duration: 1, ease: "power2.in",
       scrollTrigger:{
        trigger: mainContent,
        toggleActions: "play none none none",
        once: true
      },
    }
  );
});
//====== ANIMATION SCRIPT END =========

const dividers = gsap.utils.toArray(".divider");
dividers.forEach((divider, i)=>{
  const anim = gsap.fromTo(divider,
    { opacity:0, width:"0%", transformOrigin:"left"},
    { opacity:1, width:"100%", duration:1.5, ease:"power4.inOut"}
  )
  ScrollTrigger.create({
    trigger: divider,
    animation: anim,
    toggleActions: "play",
    once: true,
    duration: 1.5,
    // delay:-0.1,
    stagger:0.1,
    ease: "power4.inOut",
  });
})


// ===============
const steps = gsap.utils.toArray(".step");
const steptl = gsap.timeline({
  scrollTrigger:{
    trigger:".process",
    start:"top 70%",
    once:true
  }
});

steps.forEach((step)=>{
    const number = step.querySelector(".number");
    const line = step.querySelector(".line");
    const lineFill = step.querySelector(".line-fill");
    const heading = step.querySelector(".process-heading");
    const text = step.querySelector(".process-subheading");
    const divider = step.querySelector(".divider");

    // Fill vertical lineFill
    if(line){
      steptl.to(line,{
        opacity:1,
        duration:0.35,
        stagger:0.05,
        ease:"power2.out"
      });
    }
    // Fill vertical lineFill
    if(lineFill){
      steptl.to(lineFill,{
        scaleY:1,
        duration:0.5,
        dealy:0.2,
        ease:"power2.out"
      });
    }

    // Number
    steptl.to(number,{
      opacity:1,
      y:0,
      duration:0.35,
      delay:-0.25,
      color:"#d89a29"
    },"<10%");

    // Heading
    steptl.to(heading,{
      opacity:1,
      y:0,
      duration:.45,
      ease:"power3.out"
    },"<");

    // Paragraph
    steptl.to(text,{
      opacity:1,
      y:0,
      duration:.5,
    },"<0.15");

    // Divider
    if(divider){
      steptl.to(divider,{
        scaleX:1,
        duration:.5,
      },"<0.1");
    }
});
// ===============

//====== Filter Portfolio Start ============
const tabBtns = document.querySelectorAll(".btn--tab");
tabBtns.forEach((filterBtn) => {
  filterBtn.addEventListener("click", (e)=> filterCards(e.target.dataset.value.toLowerCase()));
});


//==== FILTER PORTFOLIO START ========
function filterCards(category){
  const cards = document.querySelectorAll('.filter-projects');
  cards.forEach((card) => {
    let cardCategories = card.dataset.category.toLowerCase().split(' ');
    const isVisible = category === "all" || cardCategories.includes(category)
    card.classList.toggle("show", isVisible);
    gsap.from(card,
      {
        opacity:0,
        scale:0.97,
        duration:0.75,
        stagger:0.15,
        ease:"power3.out",
      }
    );
  });
  updateButtonState(category);
}


document.querySelectorAll('.marquee__track').forEach(marqueeTrack => {
  const marqueeSlide = marqueeTrack.querySelector('.marquee__slide');
  const duration = marqueeTrack.dataset.duration || 20;
  const length = marqueeTrack.dataset.repeat || 2;
  
  if(marqueeSlide){
    for(let i=1; i <= length; i++){
      marqueeTrack.appendChild(marqueeSlide?.cloneNode(true))
    }
  }
  
  const animations = [];

  marqueeTrack.querySelectorAll('.marquee__slide').forEach(element => {
    const animation = gsap.to(element, { 
      x: "-100%", 
      repeat: -1, 
      duration: duration, 
      ease: 'linear' 
    })
    animations.push(animation)
  })
})

  
//----- Update Button State -----
function updateButtonState(category){
  tabBtns.forEach((tabBtn) => {
    const isActive = tabBtn?.dataset?.value === category;
    tabBtn.classList.toggle("active", isActive);
  });
}
//====== FILTER PORTFOLIO END =============

window.addEventListener("load",()=>{
  hideLoader();
  bannerContentsAnimation();
  tabBtns.length && filterCards('all');
});

// Lenis scroll event
const onLenisScroll =()=>{
  checkScroll();
  updateCounter();
  ScrollTrigger.update();
}

lenis.on('scroll', onLenisScroll);

// Sync Lenis with GSAP
gsap.ticker.add((time)=>{
  lenis.raf(time * 1000);
});

// Disable GSAP lag smoothing for better performance
gsap.ticker.lagSmoothing(0);
